import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";

export const headCells = [
  {
    id: "journey_name",
    numeric: false,
    disablePadding: true,
    label: "Journey name",
  },
  {
    id: "description",
    numeric: true,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "last_edited_date",
    numeric: true,
    disablePadding: false,
    label: "Last edited date",
  },
  {
    id: "stage",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },

  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
export const subheadCells = [
  {
    id: "step_name",
    numeric: false,
    disablePadding: true,
    label: "Step Name",
  },
  {
    id: "description",
    numeric: true,
    disablePadding: false,
    label: "Description",
  },
  {
    id: "last_edited_date",
    numeric: true,
    disablePadding: false,
    label: "Last edited date",
  },
  {
    id: "stage",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },

  {
    id: "action",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
